export const locale = {
  lang: "fr",
  data: {
    annualDeclaration: {
      fillForm: "Remplir le formulaire",
      noNeedToFillForm: "Formulaire annuel {{year}} non requis",
      downloadSummary: "Télécharger le sommaire",
      registerReport:
        "Télécharger le rapport complet des informations au registre des sociétés",
      registerReportTitle: "Formulaire du registre de société",
    },
    company: {
      formState: {
        status: {
          Payed: "Payé",
        },
      },
    },
  },
};
